var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCb1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 259,
    viewBox: "0 0 244 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9737 235.779C102.482 245.263 129.398 246.579 154.714 239.532C180.031 232.485 202.396 217.452 218.48 196.67L216.528 195.16C200.769 215.521 178.857 230.25 154.052 237.154C129.248 244.059 102.877 242.769 78.8644 233.477L77.9737 235.779Z",
    stroke: "#A2F8C5",
    strokeOpacity: 0.75,
    strokeWidth: 30
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCb1);
export default __webpack_public_path__ + "static/media/cb1.cb51e73f6800eba51ce8ed74d709ffda.svg";
export { ForwardRef as ReactComponent };